import Head from 'next/head'
import { LOGIN, REGISTER, CONFIRM, RESET } from '@mc/authentication'
import { useTranslation } from '@mc/i18n'

interface MetaProps {
  view: typeof LOGIN | typeof REGISTER | typeof CONFIRM | typeof RESET
}

export const Meta = ({ view }: MetaProps) => {
  const { t } = useTranslation('@mc/next')

  if (view === LOGIN) {
    return (
      <Head>
        <meta
          content={t('authentication.login.meta.description')}
          name='description'
        />
      </Head>
    )
  }

  return <></>
}
